import Swiper from 'swiper/dist/js/swiper';
import * as helpers from '../../js/helpers';

export default function publicationCoverflowSlider() {
    const publicationBlock = document.querySelector('.alire__container');

    if (publicationBlock === null) {
        return;
    }

    const carousels = document.querySelectorAll('.alire__carousel');
    [...carousels].forEach((el) => {
        const parent = helpers.findAncestor(el, 'alire');
        if (parent) {
            const next = parent.querySelector('.alire__control.-next');
            const prev = parent.querySelector('.alire__control.-prev');

            if (helpers.hasClass(parent, '-coverflow-left')) {
                const swiper = new Swiper(el, {
                    effect: 'coverflow',
                    grabCursor: true,
                    centeredSlides: true,
                    slidesPerView: 'auto',
                    loop: true,
                    simulateTouch: true,
                    coverflowEffect: {
                        rotate: 16,
                        stretch: 30,
                        depth: 200,
                        modifier: 1,
                        slideShadows: false,
                    },
                    navigation: {
                        nextEl: next,
                        prevEl: prev,
                    },
                    breakpoints: {
                        1279: {
                            slidesPerView: 1,
                            coverflowEffect: {
                                rotate: 0,
                                stretch: 0,
                                depth: 0,
                            },
                        },
                    },
                });
            } else if (helpers.hasClass(parent, '-coverflow-right')) {
                const swiper = new Swiper(el, {
                    effect: 'coverflow',
                    grabCursor: true,
                    centeredSlides: true,
                    slidesPerView: 'auto',
                    loop: true,
                    simulateTouch: true,
                    coverflowEffect: {
                        rotate: 20,
                        stretch: 85,
                        depth: 200,
                        modifier: 1,
                        slideShadows: false,
                    },
                    navigation: {
                        nextEl: next,
                        prevEl: prev,
                    },
                    breakpoints: {
                        767: {
                            slidesPerView: 1,
                            coverflowEffect: {
                                rotate: 0,
                                stretch: 0,
                                depth: 0,
                            },
                        },
                    },
                });
            } else {
                const swiper = new Swiper(el, {
                    effect: 'coverflow',
                    grabCursor: true,
                    centeredSlides: true,
                    slidesPerView: 'auto',
                    loop: true,
                    simulateTouch: true,
                    coverflowEffect: {
                        rotate: 27,
                        stretch: 70,
                        depth: 230,
                        modifier: 1,
                        slideShadows: false,
                    },
                    navigation: {
                        nextEl: next,
                        prevEl: prev,
                    },
                    breakpoints: {
                        767: {
                            slidesPerView: 1,
                            coverflowEffect: {
                                rotate: 0,
                                stretch: 0,
                                depth: 0,
                            },
                        },
                    },
                });
            }

            const publicationControl = parent.querySelectorAll('.alire__control');

            if (helpers.hasClass(el, 'swiper-container-horizontal')) {
                for (let i = 0; i < publicationControl.length; i++) {
                    publicationControl[i].style.display = 'block';
                }
            }
        }
    });
}
